export default {
  state: {
    bots: [],
    models: [],
    consumption: [],
    selectedApp: null,
    testAPIResponse: {},
  },
  getters: {
    "llm/query":
      (state) =>
      ({ query, getBot }) => {
        const fallback = [];
        if (!state.bots || !state.bots.length) return fallback;
        const result = state.bots.filter(
          (app) =>
            (app.activeModel &&
              app.activeModel.toLowerCase().includes(query.toLowerCase())) ||
            (app.botID &&
              app.botID.toLowerCase().includes(query.toLowerCase())) ||
            (getBot(app.botID) &&
              getBot(app.botID).title &&
              getBot(app.botID)
                .title.toLowerCase()
                .includes(query.toLowerCase()))
        );
        return result && result.length ? result.reverse() : fallback;
      },
    "llm/get": (state) => {
      return state.bots;
    },
    "llm/consumption": (state) => {
      return state.consumption;
    },
    "llm/models": (state) => {
      return state.models;
    },
    "llm/testAPIResponse": (state) => {
      return state.testAPIResponse;
    },
  },
  mutations: {
    "llm/add": function (state, data) {
      state.bots.splice(0, 0, data);
    },
    "llm/setConsumption": function (state, data) {
      state.consumption = data;
    },
    "llm/set": function (state, data) {
      state.bots = data;
    },
    "llm/select": function (state, data) {
      state.selectedApp = data;
    },
    "llm/models": function (state, data) {
      state.models = data;
    },
    "llm/testAPIResponse": function (state, { data, key }) {
      state.testAPIResponse[key] = data;
    },
  },
  actions: {
    "llm/get": async function ({ commit, dispatch }, accountID) {
      try {
        dispatch("setLoader", true);
        const { data } = await this._vm.$http_llm.get(`/settings/${accountID}`);
        dispatch("setLoader", false);
        commit("llm/set", data);
        return Promise.resolve(data);
      } catch (err) {
        commit("llm/set", []);
        throw err;
      }
    },

    "llm/consumption": async function ({ commit, dispatch }, accountID) {
      try {
        dispatch("setLoader", true);
        const { data } = await this._vm.$http_llm.get(
          `/consumption/${accountID}`
        );
        dispatch("setLoader", false);
        commit("llm/setConsumption", data);
        return data;
      } catch (err) {
        commit("llm/setConsumption", []);
        throw err;
      }
    },

    "llm/add": async function ({ dispatch }, { accountID, botID, data }) {
      try {
        const { res } = await this._vm.$http_llm.post(
          `/settings/${accountID}/${botID}`,
          data
        );
        dispatch("llm/get", accountID);
        return res;
      } catch (err) {
        throw err;
      }
    },
    "llm/update": async function ({ dispatch }, { accountID, botID, data }) {
      try {
        const { res } = await this._vm.$http_llm.put(
          `/settings/${accountID}/${botID}`,
          data
        );
        dispatch("llm/get", accountID);
        return res;
      } catch (err) {
        throw err;
      }
    },
    "llm/testAPIRequest": async function ({ commit }, { tool, key }) {
      try {
        const { data } = await this._vm.$http_llm[
          tool.api.method.toLowerCase()
        ](tool.api.endpoint, tool.api.body, {
          headers: tool.api.headers,
        });
        commit("llm/testAPIResponse", { data, key });
        return data;
      } catch (err) {
        commit("llm/testAPIResponse", { data: err.message, key });
        throw new Error(err.response ? err.response.data.message : err.message);
      }
    },

    "llm/models": async function ({ commit }) {
      try {
        const { data } = await this._vm.$http_llm.get(`/models`);

        commit("llm/models", data);
        return data;
      } catch (err) {
        commit("llm/models", []);
        throw new Error(err.response ? err.response.data.message : err.message);
      }
    },
  },
};
